__turbopack_context__.v({
  "blockquote": "index-module__SN-OMW__blockquote",
  "code": "index-module__SN-OMW__code",
  "h1": "index-module__SN-OMW__h1",
  "h2": "index-module__SN-OMW__h2",
  "h3": "index-module__SN-OMW__h3",
  "h4": "index-module__SN-OMW__h4",
  "hr": "index-module__SN-OMW__hr",
  "link": "index-module__SN-OMW__link",
  "markdownContainer": "index-module__SN-OMW__markdownContainer",
  "ol": "index-module__SN-OMW__ol",
  "paragraph": "index-module__SN-OMW__paragraph",
  "pre": "index-module__SN-OMW__pre",
  "strong": "index-module__SN-OMW__strong",
  "table": "index-module__SN-OMW__table",
  "tableWrapper": "index-module__SN-OMW__tableWrapper",
  "td": "index-module__SN-OMW__td",
  "th": "index-module__SN-OMW__th",
  "tr": "index-module__SN-OMW__tr",
  "ul": "index-module__SN-OMW__ul",
});
